import React, { Component } from 'react'
import CommonTableModule from './../CommonTable/CommonTableModule';
import { Card, Alert, Spinner, Badge, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import axios from "axios";
import { DateTimeFormat } from '../DateFormat/DateTimeFormat';
import CommonLoader from '../loaderComponent/CommonLoader';
import { hasPermission } from '../../utils/usePermission';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

export default class ProjectList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projects: [],
      loading: true,
      hasError: false,
      errMsg: ""
    };
  }

  async componentDidMount() {
    this.setState({ loading: true })
    const token = localStorage.getItem("token");
    if (!token) {
      this.setState({ hasError: true, errMsg: "Unauthorized! Please log in.", loading: false });
      return;
    }
    const headers = { Authorization: `Bearer ${token}` };
    try {
      const response = await axios.get('/project', { headers });
      this.setState({ projects: response?.data });
      setTimeout(() => {
        this.setState({ loading: false });
      }, 900);
    } catch (error) {
      console.error("Error fetching project:", error);
      let errorMessage = "Failed to load project.";

      if (error.response && error.response.status === 403) {
        errorMessage = "Access Denied! Admin privileges required.";
      }
      this.setState({ hasError: true, errMsg: errorMessage, loading: false });
    }
  }
  onAddRestOfDays = (data) => {
    if (!data) {
      console.error("No rowData provided!");
      return;
    }
    this.props.history.push({
      pathname: `/add-days/${data.id}`,
      state: { data }
    });
  }

  onEditProjectDetails = (data) => {
    if (!data) {
      console.error("No rowData provided!");
      return;
    }
    this.props.history.push({
      pathname: `/project-edit/${data.id}`,
      state: { data }
    });
  }

  handleAddProject = () => {
    this.props.history.push('/project-add')
  }

  render() {
    const columns = [
      { key: "id", label: "ID" },
      { key: "customerId", label: "Customer Id" },
      { key: "name", label: "Name" },
      { key: "description", label: "Description" },
      {
        key: "start_date",
        label: "Start Date",
        render: (value) => value ? DateTimeFormat(value) : 'N/A',
      },
      {
        key: "target_date",
        label: "Target Date",
        render: (value) => value ? DateTimeFormat(value) : 'N/A',
      },
      {
        key: "end_date",
        label: "End Date",
        render: (value) => value ? DateTimeFormat(value) : 'N/A',
      },
      // {
      //   key: "status",
      //   label: "Status",
      //   render: (value) => (
      //     <Badge variant={value === "Active" ? "success" : "danger"}>{value.toUpperCase()}</Badge>
      //   ),
      // },

      {
        key: "status",
        label: "Status",
        render: (value) => {
          const status = value?.toLowerCase();
          const isActive = status === "active";

          const styles = {
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            padding: "4px 12px",
            borderRadius: "20px",
            fontSize: "0.75rem",
            fontWeight: 600,
            textTransform: "uppercase",
            backgroundColor: isActive ? "#E6F4EA" : "#FBEAEA",
            color: isActive ? "#216e39" : "#A94442",
            border: `1px solid ${isActive ? "#B6E2C5" : "#F1B5B5"}`,
            minWidth: "80px",
            textAlign: "center",
          };

          return (
            <span style={styles}>
              {isActive ? <FaCheckCircle /> : <FaTimesCircle />} {value}
            </span>
          );
        },
      },

      {
        key: "actions",
        label: "Action",
        render: (value, rowData) => {
          return (
            <div className='d-flex align-items-center gap-1'>
              {hasPermission('M6S1') && (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id={`tooltip-edit-${rowData?.id || "default"}`}>Add Rest Of Days</Tooltip>}
                >
                  <Button
                    size="sm"
                    variant="outline-info"
                    className="mr-2 info"
                    onClick={() => this.onAddRestOfDays(rowData)}
                  >
                    <i className="fa fa-plus-circle"></i>
                  </Button>
                </OverlayTrigger>
              )}
              {hasPermission('M6S2B2') && (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id={`tooltip-edit-${rowData?.id || "default"}`}>Edit Project Details</Tooltip>}
                >
                  <Button
                    size="sm"
                    variant="outline-info"
                    className="mr-2 info"
                    onClick={() => this.onEditProjectDetails(rowData)}
                  >
                    <i className="fa fa-edit"></i>
                  </Button>
                </OverlayTrigger>
              )}
            </div>
          );
        }
      },
    ];
    return (
      <div className="container-fluid pt-4">
        <CommonLoader isLoading={this.state.loading}>
          {hasPermission('M1S2B1') && (
            <div className="add-role">
              <Button
                variant="primary"
                className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button"
                onClick={this.handleAddProject}
              >
                <i className="fa fa-plus-circle" aria-hidden="true"></i>
                Add Project
              </Button>
            </div>

            // <div className='add-role'>
            //   <Button variant='outline-primary' onClick={this.handleAddProject}> <i className="fa fa-plus-circle"></i> Add Project</Button>
            // </div>
          )}
          <Card className="shadow-sm rounded border-0">
            <Card.Header>
              <b>Project List</b>
            </Card.Header>
            <Card.Body>
              {this.state.hasError ? (
                <Alert variant="outline-danger" className="m-3">
                  {this.state.errMsg}
                </Alert>
              ) : (
                <CommonTableModule columns={columns} data={this.state.projects} />
              )}
            </Card.Body>
          </Card>
        </CommonLoader>
      </div>
    )
  }
}
